module.exports = __webpack_public_path__ + "img/uvazujte.000ee43a.jpg";